export const PRINT_BASE_STYLES = `
  @page { size: A4 landscape; margin: 12mm 10mm; }
  body { font-family: 'Inter', 'Segoe UI', Arial, sans-serif; color: #0f172a; margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .brand { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; padding-bottom: 12px; border-bottom: 2px solid #e5e7eb; }
  .brand img { width: 40px; height: 40px; object-fit: contain; }
  .brand-title { font-size: 14px; font-weight: 700; color: #111827; margin: 0; }
  h1 { margin: 0 0 8px 0; font-size: 22px; font-weight: 700; letter-spacing: -0.02em; }
  .subtitle { margin: 0 0 16px 0; font-size: 11px; line-height: 1.5; color: #4b5563; white-space: pre-line; max-width: 100%; }
  h2 { margin: 0 0 10px 0; font-size: 13px; color: #4b5563; font-weight: 500; }
  h3 { margin: 14px 0 8px; font-size: 15px; }
  .meta { margin-bottom: 12px; font-size: 12px; color: #374151; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 12px; }
  th, td { border: 1px solid #d1d5db; padding: 6px 7px; font-size: 11px; text-align: left; vertical-align: top; }
  th { background: #f3f4f6; font-weight: 600; }
  th.amount-cell, td.amount-cell,
  th.amount-col, td.amount-col,
  .amount, td.amount, th.amount { text-align: right !important; font-variant-numeric: tabular-nums; }
  .status-badge { display: inline-block; border: 1px solid #d1d5db; border-radius: 999px; padding: 2px 8px; font-size: 11px; }
  .print-hidden { display: none !important; }
`;

/** Extra rules for Senior Management MI report (scoped under .sm-report-print). */
export const SENIOR_MANAGEMENT_PRINT_STYLES = `
  /* Report body already includes cover + branding; hide duplicate shell from print template */
  body > .brand,
  body > h1,
  body > .subtitle,
  .report-main-content > .brand,
  .report-main-content > h1,
  .report-main-content > .subtitle {
    display: none !important;
  }
  .sm-report-print {
    background: #f8fafc !important;
    color: #0f172a !important;
    font-size: 10px !important;
    line-height: 1.4 !important;
    padding: 0 !important;
  }
  .sm-print-cover {
    page-break-after: always !important;
    break-after: page !important;
  }
  .sm-cover, .sm-print-cover {
    box-shadow: none !important;
    border: 1px solid #e2e8f0 !important;
  }
  .sm-cover__inner { display: block !important; }
  .sm-cover__meta-card { break-inside: avoid !important; }
  .sm-exec-dashboard {
    page-break-inside: avoid !important;
    margin-bottom: 10px !important;
  }
  .sm-exec {
    page-break-inside: avoid !important;
    margin-bottom: 8px !important;
  }
  .sm-exec__groups {
    gap: 10px !important;
  }
  .sm-exec__grid {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
  }
  .sm-kpi-card {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    box-shadow: 0 1px 2px rgba(15,23,42,0.06) !important;
    border: 1px solid #e2e8f0 !important;
    padding: 8px 10px !important;
  }
  .sm-kpi-card--compact .sm-kpi-card__value {
    font-size: 16px !important;
  }
  .sm-kpi-card--compact .sm-kpi-card__label {
    font-size: 9px !important;
  }
  .sm-charts {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 8px !important;
    margin-bottom: 12px !important;
  }
  .sm-charts--exec {
    margin-top: 8px !important;
  }
  .sm-chart-card {
    break-inside: avoid !important;
    border: 1px solid #e2e8f0 !important;
  }
  .sm-portfolio { page-break-inside: avoid !important; margin-bottom: 12px !important; }
  .sm-section-head {
    page-break-before: always !important;
    break-before: page !important;
    break-after: avoid-page !important;
    margin-top: 0 !important;
    padding-top: 8px !important;
    border-bottom: 2px solid #e2e8f0 !important;
  }
  .sm-section-head--first { page-break-before: auto !important; break-before: auto !important; }
  h2.sm-exec__title,
  h2.sm-portfolio__title,
  h2.sm-annex__title {
    break-after: avoid !important;
  }
  .sm-mini-kpi {
    display: grid !important;
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin-bottom: 8px !important;
  }
  .sm-mini-kpi__item {
    break-inside: avoid !important;
    border: 1px solid #e2e8f0 !important;
    padding: 6px !important;
  }
  .sm-subhead { page-break-after: avoid !important; }
  .sm-empty {
    break-inside: avoid !important;
    border: 1px dashed #cbd5e1 !important;
    padding: 20px !important;
  }
  .sm-annex {
    page-break-before: always !important;
    break-before: page !important;
    border-top: 2px solid #e2e8f0 !important;
    padding-top: 12px !important;
  }
  .sm-print-annex-block {
    page-break-inside: auto !important;
  }
  .sm-print-annex-block .sm-table-wrap {
    page-break-inside: auto !important;
  }
  .sm-table-wrap {
    max-height: none !important;
    overflow: visible !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 8px !important;
    margin-bottom: 10px !important;
    box-shadow: none !important;
  }
  .sm-table-meta,
  .sm-annex-meta {
    font-size: 8px !important;
  }
  .sm-table { font-size: 9px !important; }
  .sm-table-wrap th,
  .sm-table-wrap td {
    padding: 4px 6px !important;
    font-size: 9px !important;
  }
  .sm-annex-table .sm-table {
    font-size: 8px !important;
  }
  .sm-annex-table .sm-table-wrap th,
  .sm-annex-table .sm-table-wrap td {
    font-size: 8px !important;
  }
  .sm-table tbody tr:nth-child(even) td {
    background: #f8fafc !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .sm-table thead th {
    position: static !important;
    background: #0f172a !important;
    color: #f8fafc !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .sm-table thead { display: table-header-group !important; }
  .sm-toolbar-note { font-size: 8px !important; }
`;
